const initCompany = {
  legal_name: '',
  type: 'non-official',
  vat_number: '',
  coc_number: '',
  country_code: 'nl',
}
export default initCompany
